import { Leaf, Mail, Phone, Instagram, Facebook } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { Link } from "react-router-dom";

export const Footer = ({ content }) => (
  <footer id="contacto" data-testid="footer" className="bg-forest-900 text-sand">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20">
      <div className="grid md:grid-cols-2 gap-12 items-end border-b border-sand/15 pb-16">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase font-semibold text-terracotta-300">¿Listo para transformar tu vida?</span>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight mt-4 leading-[1.05]">
            Haz tu pedido hoy mismo
          </h2>
        </div>
        <div className="flex md:justify-end">
          <a
            href={`https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(content.whatsapp_message)}`}
            target="_blank" rel="noreferrer"
            data-testid="footer-whatsapp-btn"
            className="rounded-full bg-terracotta-500 text-white px-9 py-4 text-sm font-semibold hover:bg-terracotta-600 transition-colors hover:-translate-y-1 duration-300"
          >
            Contactar por WhatsApp
          </a>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-10 pt-16">
        <div>
          <div className="flex items-center gap-3">
            <img src={resolveImg(content.logo_url)} alt={content.brand_name} className="h-11 w-11 object-contain rounded-full bg-sand/90 p-1" />
            <span className="font-serif text-xl">{content.brand_name}</span>
          </div>
          <p className="text-sand/60 mt-4 max-w-xs text-sm leading-relaxed">
            Distribuidor de productos naturales Vida Divina. Bienestar 100% natural, resultados reales.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-sand/50 mb-4">Navegación</div>
          <ul className="space-y-3 text-sand/80 text-sm">
            <li><a href="#catalogo" className="hover:text-terracotta-300">Catálogo</a></li>
            <li><a href="#beneficios" className="hover:text-terracotta-300">Beneficios</a></li>
            <li><a href="#nosotros" className="hover:text-terracotta-300">Nosotros</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-sand/50 mb-4">Contacto</div>
          <ul className="space-y-3 text-sand/80 text-sm">
            <li className="flex items-center gap-2"><Phone size={15} className="text-terracotta-300" /> +{content.whatsapp_number}</li>
            {content.email && <li className="flex items-center gap-2"><Mail size={15} className="text-terracotta-300" /> {content.email}</li>}
          </ul>
          <div className="flex gap-3 mt-5">
            {content.instagram_url && (
              <a href={content.instagram_url} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full bg-sand/10 flex items-center justify-center hover:bg-terracotta-500"><Instagram size={17} /></a>
            )}
            {content.facebook_url && (
              <a href={content.facebook_url} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full bg-sand/10 flex items-center justify-center hover:bg-terracotta-500"><Facebook size={17} /></a>
            )}
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-16 pt-8 border-t border-sand/15 text-sand/50 text-xs">
        <span className="flex items-center gap-2"><Leaf size={13} className="text-terracotta-300" /> © {new Date().getFullYear()} {content.brand_name}. Todos los derechos reservados.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-sand transition-colors">Acceso Administrador</Link>
      </div>
    </div>
  </footer>
);
